import { useEffect, useState } from 'react';

const InputField = ({ label, type = 'text', value, onChange, disabled = false }) => (
  <div>
    <label className='block text-[12px] font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-xs
        ${disabled
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
          : 'focus:border-indigo-500 focus:ring-indigo-500'}
      `}
    />
  </div>
);

const IndividualContent = ({ onChangeData }) => {
  const [form, setForm] = useState({
    mes: '',
    nombre: '',
    rut: '',
    diasTrab: 0,
    cargo: '',
    sueldoBase: 0,
    gratificacion: 0,
    otrosImponiblesBonosComisionesHorasExtrasAguinaldoSemanaCorrida: 0,
    totalImponible: 0,
    colac: 0,
    moviliz: 0,
    otrosNoImponibles: 0,
    totalNoImponible: 0,
    totalHaberes: 0,
    cotizacionAfp: 0,
    cotizacionSalud: 0,
    adicionalIsapre: 0,
    seguroCesantia: 0,
    apvRegimenB: 0,
    impuestoUnico: 0,
    retenc3: 0,
    afpCuenta2: 0,
    apvRegimenA: 0,
    anticipoSueldoQuincena: 0,
    pagoPrestamosPersonal: 0,
    pagoPrestamosInstituciones: 0,
    otrosDescuentos: 0,
    totalDescuentos: 0,
    sueldoLiquido: 0,
    segCesantiaEmpleador: 0,
    sisEmpleador: 0,
    segAccEmpleador: 0,
    aportePatronalLSociales: 0,
  });

  useEffect(() => {
    const totalImponible = Number(form.sueldoBase) + Number(form.gratificacion) +Number(form.otrosImponiblesBonosComisionesHorasExtrasAguinaldoSemanaCorrida);
    const totalNoImponible =Number(form.moviliz) +Number(form.colac) + Number(form.otrosNoImponibles);
    const totalHaberes = totalImponible + totalNoImponible;

    const totalDescuentos =
      Number(form.cotizacionAfp) +Number(form.cotizacionSalud) +Number(form.adicionalIsapre) +Number(form.seguroCesantia) +Number(form.apvRegimenA) +Number(form.impuestoUnico) +Number(form.retenc3) +
      Number(form.afpCuenta2) +Number(form.apvRegimenB) +Number(form.anticipoSueldoQuincena) +Number(form.pagoPrestamosPersonal) + Number(form.pagoPrestamosInstituciones) +Number(form.otrosDescuentos);
    
      const sueldoLiquido = totalHaberes - totalDescuentos;

    const updatedForm = {
      ...form,
      totalImponible,
      totalNoImponible,
      totalHaberes,
      totalDescuentos,
      sueldoLiquido,
    };

    setForm(updatedForm);
    onChangeData(updatedForm);
  }, [form.sueldoBase,form.gratificacion,form.otrosImponiblesBonosComisionesHorasExtrasAguinaldoSemanaCorrida,form.moviliz,form.colac,
    form.otrosNoImponibles,form.cotizacionAfp,form.cotizacionSalud,form.adicionalIsapre,form.seguroCesantia,form.apvRegimenA,form.impuestoUnico,
    form.retenc3,form.afpCuenta2,form.apvRegimenB,form.anticipoSueldoQuincena,form.pagoPrestamosPersonal,form.pagoPrestamosInstituciones,form.otrosDescuentos,]);

  const formatMonto = (value) => {
    if (value === '' || value === null || isNaN(value)) return '';
    return new Intl.NumberFormat('es-CL').format(value);
  }

  // Para campos numéricos con formato
  const handleNumericChange = (field) => (e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/\./g, '').replace(/[^\d]/g, '');
    const parsedValue = cleaned === '' ? 0 : parseInt(cleaned);
    const updatedForm = { ...form, [field]: parsedValue };
    setForm(updatedForm);
    onChangeData(updatedForm);
  }

  // Para campos string (nombre, rut, cargo, mes)
  const handleTextChange = (field) => (e) => {
    const value = e.target.value;
    const updatedForm = { ...form, [field]: value };
    setForm(updatedForm);
    onChangeData(updatedForm);
  }

  const formatRut = (input) => {
    if (!input) return ''
    let cleaned = input.replace(/[^0-9kK]/g, "").toUpperCase()
    if (cleaned.length > 9) cleaned = cleaned.slice(0, 9)
    const body = cleaned.slice(0, -1)
    const dv = cleaned.slice(-1)
    let formattedBody = ""
    for (let i = body.length - 1, j = 1; i >= 0; i--, j++) {
      formattedBody = body[i] + formattedBody
      if (j % 3 === 0 && i !== 0) {
        formattedBody = "." + formattedBody
      }
    }
    if (body.length === 0) return dv
    return `${formattedBody}-${dv}`
  }

  const cleanRut = (input) => input.replace(/[^0-9kK]/g, "").toUpperCase()

  const handleRutChange = (e) => {
    const rawValue = e.target.value;
    let cleaned = cleanRut(rawValue);
    if (cleaned.length > 9) cleaned = cleaned.slice(0, 9);
    const updatedForm = { ...form, rut: cleaned };
    setForm(updatedForm);
    onChangeData(updatedForm);
  }

    return (
    <div className="p-6 bg-white rounded-3xl shadow-md">
      {/* Fila superior de datos generales */}
      <h2 className="text-lg font-bold font-sans border-b mt-1 mb-2">Datos del Trabajador</h2>
      <div className="grid grid-cols-5 gap-4 mb-6">
        <div>
          <label className='block text-[12px] font-medium text-gray-700'>Periodo (mes)</label>
          <select
            value={form.mes}
            onChange={handleTextChange('mes')}
            className="mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-xs focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="">Seleccione un mes</option>
            {[
              'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
              'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ].map((mes) => (
              <option key={mes} value={mes}>{mes}</option>
            ))}
          </select>
        </div>
        <InputField label="Nombre del Empleado" value={form.nombre} onChange={handleTextChange('nombre')} />
        <InputField label="RUT" value={formatRut(form.rut)} onChange={handleRutChange} inputProps={{ maxLength: 12 }}/>
        <InputField label="Cargo" value={form.cargo} onChange={handleTextChange('cargo')} />
        <InputField label="Días Trabajados" type="number" value={form.diasTrab} onChange={handleNumericChange('diasTrab')} />
      </div>

      {/* Grid principal de Haberes y Descuentos */}
      <div className="grid grid-cols-2 gap-12">
        {/* Columna izquierda: Haberes */}
        <div>
          <h2 className="text-lg font-bold border-b mt-1 mb-2">Haberes</h2>
          <div className="grid grid-cols-2 gap-4">
            <InputField label="Sueldo Base" value={formatMonto(form.sueldoBase)} onChange={handleNumericChange('sueldoBase')} />
            <InputField label="Gratificación" value={formatMonto(form.gratificacion)} onChange={handleNumericChange('gratificacion')} />
            <InputField
              label="Otros Haberes Imponibles"
              value={formatMonto(form.otrosImponiblesBonosComisionesHorasExtrasAguinaldoSemanaCorrida)}
              onChange={handleNumericChange('otrosImponiblesBonosComisionesHorasExtrasAguinaldoSemanaCorrida')}
            />
            <InputField label="Total Haberes Imponibles" value={formatMonto(form.totalImponible)} onChange={handleNumericChange('totalImponible')} disabled/>
            <InputField label="Asignación Colación" value={formatMonto(form.colac)} onChange={handleNumericChange('colac')} />
            <InputField label="Asignación Movilización" value={formatMonto(form.moviliz)} onChange={handleNumericChange('moviliz')} />
            <InputField label="Otros Haberes No Imponibles" value={formatMonto(form.otrosNoImponibles)} onChange={handleNumericChange('otrosNoImponibles')} />
            <InputField label="Total Haberes No Imponibles" value={formatMonto(form.totalNoImponible)} onChange={handleNumericChange('totalNoImponible')} disabled/>
          </div>
          <div className="mt-64">
            <InputField label="Total Haberes" value={formatMonto(form.totalHaberes)} onChange={handleNumericChange('totalHaberes')} disabled/>
          </div>
        </div>
        {/* Columna derecha: Descuentos */}
        <div>
          <h2 className="text-lg font-bold border-b mt-1 mb-2">Descuentos</h2>
          <div className="grid grid-cols-2 gap-4">
            <InputField label="Cotización AFP (comisión AFP incluida)" value={formatMonto(form.cotizacionAfp)} onChange={handleNumericChange('cotizacionAfp')} />
            <InputField label="Cotización Salud (7%)" value={formatMonto(form.cotizacionSalud)} onChange={handleNumericChange('cotizacionSalud')} />
            <InputField label="Adicional Salud" value={formatMonto(form.adicionalIsapre)} onChange={handleNumericChange('adicionalIsapre')} />
            <InputField label="Seguro Cesantía" value={formatMonto(form.seguroCesantia)} onChange={handleNumericChange('seguroCesantia')} />
            <InputField label="APV Régimen A" value={formatMonto(form.apvRegimenA)} onChange={handleNumericChange('apvRegimenA')} />
            <InputField label="Impuesto Único" value={formatMonto(form.impuestoUnico)} onChange={handleNumericChange('impuestoUnico')} />
            <InputField label="Retención Adicional 3% (préstamo tasa cero)" value={formatMonto(form.retenc3)} onChange={handleNumericChange('retenc3')} />
            <InputField label="AFP Cuenta 2" value={formatMonto(form.afpCuenta2)} onChange={handleNumericChange('afpCuenta2')} />
            <InputField label="APV Régimen B" value={formatMonto(form.apvRegimenB)} onChange={handleNumericChange('apvRegimenB')} />
            <InputField label="Anticipo Sueldo" value={formatMonto(form.anticipoSueldoQuincena)} onChange={handleNumericChange('anticipoSueldoQuincena')} />
            <InputField label="Pago Préstamos Personal" value={formatMonto(form.pagoPrestamosPersonal)} onChange={handleNumericChange('pagoPrestamosPersonal')} />
            <InputField label="Pago Préstamos Instituciones" value={formatMonto(form.pagoPrestamosInstituciones)} onChange={handleNumericChange('pagoPrestamosInstituciones')} />
            <InputField label="Otros Descuentos" value={formatMonto(form.otrosDescuentos)} onChange={handleNumericChange('otrosDescuentos')} />
          </div>
          <div className="mt-6">
            <InputField label="Total Descuentos" value={formatMonto(form.totalDescuentos)} onChange={handleNumericChange('totalDescuentos')} disabled/>
          </div>
          <div className="mt-4">
            <InputField label="Sueldo Líquido" value={formatMonto(form.sueldoLiquido)} onChange={handleNumericChange('sueldoLiquido')} disabled/>
          </div>
        </div>
      </div>
    </div>
  );

};

export default IndividualContent;
